import React, { useState, useEffect, useRef } from 'react';

import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { MaterialDatePickerField } from 'Components/Inputes/MaterialDatePickerField';
import { SelectForOnboardingReport as TRANSACTION_FILTER } from 'Components/Api/NSDLOnboardingAPI';
import { StatusEdit } from 'Pages/InnerPages/NSDLOnboarding/ManualStatusUpdate';
import { ViewData } from 'Pages/InnerPages/NSDLOnboarding/ViewData';
import { ManualTIDMIDUpdate } from 'Pages/InnerPages/NSDLOnboarding/ManualTIDMIDUpdate';
import {
    Container,
    Grid,
    MenuItem,
    CircularProgress,
    Box,
    Icon
} from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import ReactTable from 'Components/ReactTable/ReactTable';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    PLEASE_SELECT_VALID,
} from 'Components/Helper/Messages';
import { CustomModalWithScroll } from 'Components/Modal/CustomModalWithScroll';
import HOCLoader from 'Components/Loader/HOCLoader';
import Accordion from '@material-ui/core/Accordion';
import HOCAccordion from 'Components/CustomAccordion/HOCAccordion';

import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import {
    StatusItems,
    ExportTypeItems
} from 'Components/ReportHelper';
import { PrimaryButton } from 'Components/Inputes/CustomButton';
import { useHistory } from 'react-router';
import { CustomModal } from 'Components/Modal/CustomModal';
import excel from 'Assets/Images/excel.svg';
import AsyncAutoComplete from 'Components/Inputes/AsyncAutoComplete';
import { SelectUserForDropDownForCashCollection as USER_SELECT_FOR_DROPDOWN } from 'Components/Api/UsersApi';
import { ADMIN_CODE } from 'Components/Helper/Messages';
import { OnboardingHeaderSummary } from 'Components/SummaryCards/OnboardingHearderSummary';
const CustomAccordion = HOCAccordion(Accordion);
const CustomContainer = HOCLoader(Container);
export const OnboardingReport = () => {
    const formRef = useRef();
    const classes = commonStyle();
    const [transactions, setTransactions] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);

    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');

    const [isSuccessFailOpen, setIsSuccessFailOpen] = useState(false);
    const [OnbaordingID, setOnbaordingID] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [openFilter, setOpenFilter] = useState(true);
    const [TakeCount, setTakeCount] = useState(10);
    const [SkipCount, setSkipCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [SearchText, setSearchText] = useState('');
    const [downline, setDownline] = useState([]);
    const [IsDisplayCriteria, setIsDisplayCriteria] = useState(false);
    const [CriteriaTextLabel, setCriteriaTextLabel] = useState(false);
    const [isTIDMIDOpen, setIsTIDMIDOpen] = useState(false);
    const history = useHistory();
    const [selectedRow, setSelectedRow] = useState(null);
    const [isViewDataOpen, setIsViewDataOpen] = useState(false);
    const [isAdminRole, setIsAdminRole] = useState(false);
    const [headerSummary, setHeaderSummary] = useState({});
    const [currentUserTypeID, setCurrentUserTypeID] = useState(
        parseInt(localStorage.getItem('UserTypeID'))
    );
    const [userDefault, setUserDefault] = useState({
        UserID: 0,
        FirmName: 'Select All'
    });

    const [ModelObj] = useState({
        ToDate: new Date(),
        FromDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
        Status: 'PROCESS',
        ExportType: 'Select Download',
        IsExcelDownload: false,
        Criteria: 0,
        CriteriaText: '',
        User: userDefault,
    });

    const CheckUserRole = () => {
        if (
            ADMIN_CODE === parseInt(currentUserTypeID)
        )
            setIsAdminRole(true);

    };
    const showUserList = () => {
        if (isAdminRole === true) return true;
    };

    const callSelectData = async (
        TakeCount,
        SkipCount,
        SearchText,
        SortColumnName,
        SortDirection
    ) => {
        let requestObj = {
            TakeCount: TakeCount,
            SkipCount: SkipCount,
            Search: SearchText,
            SortColumnName: SortColumnName,
            SortDirection: SortDirection,
            FromDate: formRef.current.values.FromDate,
            ToDate: formRef.current.values.ToDate,
            Status: formRef.current.values.Status,
            ExportType: formRef.current.values.ExportType,
            IsExcelDownload: formRef.current.values.IsExcelDownload,
            Criteria: formRef.current.values.Criteria,
            CriteriaText: formRef.current.values.CriteriaText,
            UserID: formRef.current.values.User.UserID,
        };
        //if (formRef.current.values.IsExcelDownload === false) setTransactions();

        setIsError(false);
        setLoading(true);
        var requestJSON = JSON.stringify(requestObj);
        var response = await TRANSACTION_FILTER(requestJSON);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }
        setSeverity('success');
        var data = JSON.parse(response.data);

        if (data.IsExcelDownload) {
            downloadFile(data.ReportPath, 'Onboarding Report');
            return;
        }
        if (SkipCount <= 0) {
            setTotalCount(data.Count);
            setHeaderSummary(data.HeaderSummary);
        }
        setTransactions(data.list);
    };

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        setSubmitting(true);
        setTransactions([]);
        createColumns();
        await callSelectData(TakeCount, SkipCount, '', '', '');
        setSubmitting(false);
    };

    function downloadFile(URL, Title) {
        let a = document.createElement('a');
        a.href = URL;
        a.setAttribute('download', Title);
        a.setAttribute('target', '_blank');
        a.click();
        document.removeChild(a);
    }

    const validationSchema = Yup.object({
        FromDate: Yup.date()
            .nullable(PLEASE_SELECT_VALID + 'from date')
            .required(PLEASE_SELECT_VALID + 'date')
            .max(new Date(), PLEASE_SELECT_VALID + 'from date')
            .typeError(PLEASE_SELECT_VALID + 'from date'),

        ToDate: Yup.date()
            .nullable(PLEASE_SELECT_VALID + 'date')
            .required(PLEASE_SELECT_VALID + 'date')
            .max(new Date(), PLEASE_SELECT_VALID + 'to date')
            .typeError(PLEASE_SELECT_VALID + 'to date')
    });

    const refreshForm = () => {
        if (!formRef.current) return;
        formRef.current.handleSubmit();
    };
    useEffect(() => {
        refreshForm();
        CheckUserRole();
    }, []);
    const createColumns = () => {
        var columns = [];
        var statusIndex = 1;

        columns.push({
            label: 'BankStatus',
            name: 'BankStatus',
            hide: true
        });

        columns.push({
            label: 'UserID',
            name: 'UserID',
            hide: true
        });

        columns.push({
            label: 'Date and Time',
            name: 'DOC'
        });

        columns.push({
            label: 'Person Name',
            name: 'PersonName'
        });
        columns.push({
            label: 'Mobile Number',
            name: 'Mobile'
        });
        columns.push({
            label: 'API User Name',
            name: 'UserName'
        });

        columns.push({
            label: 'POS Serial Number',
            name: 'PosSerialNumber'
        });

        columns.push({
            label: 'Terminal ID',
            name: 'TerminalID',
        });
        columns.push({
            label: 'Merchant ID',
            name: 'MerchantID',
        });

        columns.push({
            label: 'Status',
            name: 'Status',
            customStatus: true
        });

        columns.push({
            label: 'Bank Status',
            name: 'BankStatus',
            customStatus: true
        });
        columns.push({
            label: 'Bank Remark',
            name: 'BankRemark'
        });

        var options = [];


        options.push({
            Title: 'Action',
            disabledOn: ['SUCCESS'],
            statusIndex: statusIndex,
            Callback: (values) => {
                Action(values[0]);
            }
        });

        options.push({
            Title: 'View',
            disabledOn: [''],
            statusIndex: statusIndex,
            Callback: (values) => {
                View(values[0]);
            }
        });

        options.push({
            Title: 'Edit',
            disabledOn: ['SUCCESS'],
            statusIndex: statusIndex,
            Callback: (values) => {
                Edit(values[0]);
            }
        });
        options.push({
            Title: 'Update TID MID',
            disabledOn: ['FAILURE'],
            statusIndex: statusIndex,
            Callback: (values) => {
                const row = {
                    OnbaordingID: values[0],
                    TerminalID: values[13],
                    MerchantID: values[14]
                };
                UpdateTIDMID(row);
            }
        });

        columns.splice(0, 0, {
            label: 'Action',
            name: 'OnbaordingID',
            MoreMenu: true,
            options: options
        });

        setMainColumns(columns);
    };

    const View = async (ID) => {
        setOnbaordingID(ID);
        setIsViewDataOpen(true);
    };

    const Action = async (ID) => {
        setOnbaordingID(ID);
        setIsSuccessFailOpen(true);
    };
    const Edit = async (ID) => {
        let params = {
            ID: ID,
        };
        history.push('/EditNSDLOnboarding', params);
    };

    const UpdateTIDMID = (rowData) => {
        setOnbaordingID(rowData.OnbaordingID);
        setSelectedRow(rowData);
        setIsTIDMIDOpen(true);
    };
    const TextDisplay = (setFieldValue) => {
        setFieldValue('CriteriaText', '');
        setIsDisplayCriteria(true);
    };
    const OnChangeCriteria = (value) => {
        if (value === undefined || value <= 0) {
            setIsDisplayCriteria(false);
            setCriteriaTextLabel('');
            return;
        }
        setCriteriaTextLabel(value);
        setIsDisplayCriteria(true);
        switch (value) {
            case 'MobileNumber':
                setCriteriaTextLabel('Enter Mobile Number');
                break;
            case 'PANNumber':
                setCriteriaTextLabel('Enter PAN');
                break;
            default:
                setCriteriaTextLabel('');
        }
    };

    const callSearch = async (text) => {
        if (
            text === undefined ||
            text === null ||
            text === '' ||
            text.length <= 0 ||
            text === userDefault.FirmName
        )
            return;

        var jsonObj = {
            FirmName: text
        };
        SelectUser(jsonObj);
    };

    const SelectUser = async (values) => {
        setLoading(true);
        var request = JSON.stringify(values);

        const userResponse = await USER_SELECT_FOR_DROPDOWN(request);
        setLoading(false);
        if (!userResponse.isAuthorized) LOGOUT();

        if (!userResponse.status) {
            setIsError(true);
            setSeverity('error');
            return;
        }
        var data = JSON.parse(userResponse.data);
        let objWithSelectAll = [userDefault, ...data];

        setDownline(objWithSelectAll);
    };

    return (
        <>
            <div
                style={{
                    position: 'relative'
                }}
            >
                <CustomContainer
                    isLoading={loading}
                    isError={isError}
                    alertMessage={responseMessage}
                    severity={severity}
                    onCloseCallback={(alertState) => {
                        setIsError(alertState);
                    }}
                    style={{
                        paddingTop: '20px',
                        marginTop: '20px'
                    }}
                >
                    <Formik
                        enableReinitialize={true}
                        innerRef={formRef}
                        initialValues={ModelObj}
                        validationSchema={validationSchema}
                        onSubmit={submithandle}
                        resetForm={ModelObj}
                    >
                        {({ setFieldValue, handleSubmit }) => {
                            return (
                                <Form>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <CustomAccordion
                                            title={'Onboarding Report'}
                                            open={openFilter}
                                            setOpen={(value) =>
                                                setOpenFilter(value)
                                            }
                                        >
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={2}
                                                    lg={2}
                                                >
                                                    <MaterialDatePickerField
                                                        name="FromDate"
                                                        label="From Date"
                                                        maxDate={new Date()}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={2}
                                                    lg={2}
                                                >
                                                    <MaterialDatePickerField
                                                        name="ToDate"
                                                        label="To Date"
                                                        maxDate={new Date()}
                                                    />
                                                </Grid>



                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={2}
                                                    lg={2}
                                                >
                                                    <MaterialSelect
                                                        label="Status"
                                                        name="Status"
                                                        title="Status"
                                                    >
                                                        {StatusItems}
                                                    </MaterialSelect>
                                                </Grid>
                                                {showUserList() ? (
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={2}
                                                        lg={2}
                                                    >
                                                        <Field
                                                            component={AsyncAutoComplete}
                                                            defaultValue={userDefault}
                                                            FieldName="User"
                                                            name="User"
                                                            SubFieldName="UserID"
                                                            options={downline}
                                                            getOptionLabel={(option) => option.FirmName}
                                                            textFieldProps={{
                                                                label: 'Select User'
                                                            }}
                                                            onSearchCallback={(
                                                                text
                                                            ) => {
                                                                callSearch(text);
                                                            }}
                                                            onCustomCallback={(
                                                                name, value
                                                            ) => {
                                                                setUserDefault({
                                                                    UserID: value.UserID,
                                                                    FirmName: value.FirmName
                                                                });
                                                            }}
                                                        />
                                                    </Grid>
                                                ) : null}
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={2}
                                                    lg={2}
                                                >
                                                    <MaterialSelect
                                                        label="Selection Criteria"
                                                        name="Criteria"
                                                        title="criteria"
                                                        onCustomCallback={(
                                                            name,
                                                            value
                                                        ) => {
                                                            OnChangeCriteria(
                                                                value
                                                            );
                                                        }}
                                                    >
                                                        <MenuItem
                                                            key={0}
                                                            value={0}
                                                        >
                                                            Selection Criteria
                                                        </MenuItem>
                                                        <MenuItem
                                                            key={4}
                                                            value={'MobileNumber'}
                                                            onClick={() => {
                                                                TextDisplay(
                                                                    setFieldValue
                                                                );
                                                            }}
                                                        >
                                                            Mobile Number
                                                        </MenuItem>
                                                        <MenuItem
                                                            key={5}
                                                            value={
                                                                'PANNumber'
                                                            }
                                                            onClick={() => {
                                                                TextDisplay(
                                                                    setFieldValue
                                                                );
                                                            }}
                                                        >
                                                            PAN
                                                        </MenuItem>
                                                    </MaterialSelect>
                                                </Grid>

                                                {!IsDisplayCriteria ? null : (
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={2}
                                                        lg={2}
                                                    >
                                                        <MaterialTextField
                                                            label={
                                                                CriteriaTextLabel
                                                            }
                                                            name="CriteriaText"
                                                            type="text"
                                                            placeholder={
                                                                CriteriaTextLabel
                                                            }
                                                        />
                                                    </Grid>
                                                )}
                                                <Grid item xs={12} sm={12} md={1} lg={1}>
                                                    <Icon
                                                        className={classes.CustomImageButtonStyle}
                                                        disabled={loading}
                                                        classes={{ root: classes.iconRoot }}
                                                        onClick={(e) => {
                                                            setFieldValue('IsExcelDownload', true);
                                                            handleSubmit(e);
                                                        }}
                                                    >
                                                        <img
                                                            alt=""
                                                            className={classes.imageIcon}
                                                            src={excel}
                                                        />
                                                    </Icon>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={1}
                                                    lg={1}
                                                >
                                                    <PrimaryButton
                                                        type="submit"
                                                        title="Search"
                                                        className={
                                                            classes.CustomPrimaryButtonStyle
                                                        }
                                                        disabled={loading}
                                                        onClick={(e) => {
                                                            setFieldValue(
                                                                'IsExcelDownload',
                                                                false
                                                            );
                                                            setFieldValue(
                                                                'IsPDFDownload',
                                                                false
                                                            );
                                                            handleSubmit(e);
                                                        }}
                                                    >
                                                        Search
                                                    </PrimaryButton>
                                                    {loading && (
                                                        <CircularProgress
                                                            size={24}
                                                            className={
                                                                classes.buttonProgress
                                                            }
                                                        />
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </CustomAccordion>
                                    </Grid>

                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div
                                                className={
                                                    classes.SubmitWrapper
                                                }
                                            ></div>
                                        </Box>
                                    </Grid>
                                </Form>
                            );
                        }}
                    </Formik>
                    <OnboardingHeaderSummary headerSummary={headerSummary} />
                    <ReactTable
                        data={transactions}
                        columns={mainColumns}
                        count={totalCount}
                        rowsPerPage={TakeCount}
                        serverSide={true}
                        getCallback={({ currentPage, RowsPerPage }) => {
                            setCurrentPage(currentPage);
                            setTakeCount(RowsPerPage);
                            setSkipCount(RowsPerPage * currentPage);
                            callSelectData(
                                RowsPerPage,
                                RowsPerPage * currentPage,
                                '',
                                '',
                                ''
                            );
                        }}
                        getSearchCallback={({ SearchText }) => {
                            callSelectData(
                                TakeCount,
                                SkipCount,
                                SearchText,
                                '',
                                ''
                            );
                        }}
                        getSortCallback={({ column, direction }) => {
                            callSelectData(
                                TakeCount,
                                currentPage,
                                SearchText,
                                column,
                                direction
                            );
                        }}
                    />
                    {isSuccessFailOpen ? (
                        <CustomModalWithScroll
                            isOpen={isSuccessFailOpen}
                            title=""
                            width="80%"
                            onDismissCallback={(value) => {
                                setIsSuccessFailOpen(value);
                            }}
                        >
                            <StatusEdit
                                OnbaordingID={OnbaordingID}
                                onDismissCallback={(value) => {
                                    setIsSuccessFailOpen(value);
                                }}
                            />
                        </CustomModalWithScroll>
                    ) : null}

                    {isViewDataOpen ? (
                        <CustomModalWithScroll
                            isOpen={isViewDataOpen}
                            title=""
                            width="80%"
                            onDismissCallback={(value) => {
                                setIsViewDataOpen(value);
                            }}
                        >
                            <ViewData
                                OnbaordingID={OnbaordingID}
                                onDismissCallback={(value) => {
                                    setIsViewDataOpen(value);
                                }}
                            />
                        </CustomModalWithScroll>
                    ) : null}

                    {isTIDMIDOpen && selectedRow ? (
                        <CustomModal
                            isOpen={isTIDMIDOpen}
                            title="Update TID MID"
                            width="50%"
                            onDismissCallback={(value) => {
                                setIsTIDMIDOpen(value);
                                refreshForm();
                            }}
                        >
                            <ManualTIDMIDUpdate
                                OnbaordingID={selectedRow.OnbaordingID}
                                TerminalID={selectedRow.TerminalID}
                                MerchantID={selectedRow.MerchantID}
                                onDismissCallback={(value) => {
                                    setIsTIDMIDOpen(value);
                                }}
                            />
                        </CustomModal>
                    ) : null}
                </CustomContainer>
            </div>
        </>
    );
};
